<template>
    <div>            
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeSettings">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeSettings">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mb-4">
                    <img :src="settingImg" class="img-index mr-2" alt="" />
                    <div class="align-middle text-left line-height-100 text--primary">
                        <p class="font-size-16 font-weight-bolder ma-0">
                            {{ $t('bookReading.settings') }}
                        </p>
                        <small class="font-size-12">Settings</small>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column mx-3">
                    <v-row justify="start" align="start">
                        <v-col cols="12" class="pa-0 mb-4 d-flex flex-column justify-start align-start">
                            <span class="text--primary font-size-12">{{ $t('challenge.text_size') }}</span>
                            <div class="d-flex flex-row w-100 justify-content-start align-start mt-1">
                                <FontSizeSelector
                                    v-for="(size, index) of fontSizes"
                                    :key="index"
                                    :font_size="size"
                                    :active="fontSize === size"
                                    :isBookFunctionality="isBookFunctionality"
                                    :isChallengeFunctionality="isChallengeFunctionality"
                                    class="mr-2"
                                >
                                    <span class="">{{ size }}p</span>
                                </FontSizeSelector>
                            </div>
                        </v-col>
                        <v-col cols="12" class="pa-0 d-flex flex-column justify-start align-start">
                            <span class="text--primary font-size-12">{{ $t('challenge.font') }}</span>
                            <div class="d-flex flex-row justify-start align-start mt-1">
                                <FontFamilySelector
                                    v-for="(family, index) of fontFamilies"
                                    :key="index"
                                    :font_family="family"
                                    :active="fontFamily === family.fontFamilyId"
                                    :isBookFunctionality="isBookFunctionality"
                                    :isChallengeFunctionality="isChallengeFunctionality"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from './UtilsContent.vue'
import FontSizeSelector from './items/FontSizeSelector.vue'
import FontFamilySelector from './items/FontFamilySelector.vue'

export default {
    props: {
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false }
    },
    components: {
        UtilsContent,
        FontSizeSelector,
        FontFamilySelector,
    },
    computed: {
        ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            challengeConfig: (state) => state.challenge.config
        }),
        fontSize() {
            let result = this.bookReadConf && this.bookReadConf.fontSize
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConfig.fontSize
            }
            return result
        },
        fontFamily() {
            let result = this.bookReadConf && this.bookReadConf.fontFamily
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConfig.typography
            }
            return result
        }
    },
    data() {
        return {
            settingImg: require('@/assets/img/icons/new-reading/settings-purple.svg'),
            fontSizes: ['16', '18', '22', '24', '28'],
            fontFamilies: [
                {
                    fontFamilyId: '0',
                    fontFamilyName: 'Aa',
                    fontFamilyValue: "'Poppins', sans-serif",
                },
                {
                    fontFamilyId: '1',
                    fontFamilyName: 'Aa',
                    fontFamilyValue: "'Roboto', sans-serif",
                },
                {
                    fontFamilyId: '2',
                    fontFamilyName: 'Aa',
                    fontFamilyValue: "'Comic Sans MS', arial",
                },
                {
                    fontFamilyId: '3',
                    fontFamilyName: 'Aa',
                    fontFamilyValue: "'Arial', fantasy",
                },
            ],
        }
    },
    methods: {
        closeSettings() {
            this.$emit('close-settings')
        },
    },
}
</script>
<style lang="scss">
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
.close-btn.close-btn-left{
  right: 0;
  left: -14px;
  top: -14px;
}
</style>
